import type { ArticleMeta } from '../types.ts';

import thumbSrc from './thumb.webp';

const year = new Date().getFullYear();

export const articleMeta = {
  slug: 'refinansiering-uten-sikkerhet',
  title: `Refinansiering uten sikkerhet: Slik samler du kredittkort- og forbruksgjeld i ${year}`,
  description:
    'Har du dyr kredittkort- og forbruksgjeld? Se hvordan refinansiering uten sikkerhet kan gi lavere rente og én samlet faktura uten boliglån.',
  tags: ['refinansiering', 'gjeld', 'tips'],
  publishedAt: '2026-02-01',
  thumbSrc,
  thumbAlt: 'Jente som smiler med en mobiltelefon og en abstrakt lys gul bakgrunn',
} satisfies ArticleMeta;
